import { render, staticRenderFns } from "./AdminRegistrosComponent.vue?vue&type=template&id=6d490f70&"
import script from "./AdminRegistrosComponent.vue?vue&type=script&lang=js&"
export * from "./AdminRegistrosComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports